import useTable from '../../../hooks/useTable';
import { Table } from '../../Table';
import { TableComponentProps } from '../types';

const columnLables = {
  first_funding_source_country: {
    name: 'First',
    letter: 'A'
  },
  second_funding_source_country: {
    name: 'Second',
    letter: 'B'
  },
  third_funding_source_country: {
    name: 'Third',
    letter: 'C'
  }
};

export function FundSourceCode({
  funds,
  currentDataKey,
  onChangeFund,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useTable({
    data: funds[currentDataKey]?.fund_data?.FUNDING_SOURCE_COUNTRY_CODE,
    onChangeFund,
    schema: schema.FUNDING_SOURCE_COUNTRY_CODE,
    isStaticTemplate,
    requiredFields:
      funds[currentDataKey]?.required_tables?.FUNDING_SOURCE_COUNTRY_CODE?.field_names || [],
    isMultiFunds,
    funds,
    columnLables,
    tableName: 'FUNDING_SOURCE_COUNTRY_CODE',
    order: 39 as any
  });

  return (
    <Table
      id="fca-reporttables-fund-source-code-table"
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 3 : null}
      handleChanges={onChange}
      columns={columns}
      rows={rows}
    />
  );
}
